export default __webpack_public_path__ + "static/media/742.c0dbb6d5.png";